export enum CustomerDocumentType {
  OTHER = 'OTHER',
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  STUDENT_CARD = 'STUDENT_CARD',
  SCHOOL_ID = 'SCHOOL_ID',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
}
